"use client";
import React, {  useState } from "react";
// import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { AMZ_VOUCHER, /* ICM_NAME_FULL, */ MAX_EARNING } from "@/app/utils/constants";
// import useMobile from "@/app/hooks/use-mobile";
import { Tabs, TabsContent/* , TabsList, TabsTrigger */ } from "@/components/ui/tabs";
// import { useQuery } from "@tanstack/react-query";
// import {
//     getThirdPartyUserData,
//     getUserEmail,
//     postUserCheckpointsStatus,
// } from "@/app/api/service/user";
// import { getUserReferalDetail } from "@/app/api/service/refer";
// import ReferDrawer from "@/app/refer/components/refer-drawer";
// import ReferComponent from "@/app/refer/components/refer-component";
// import StartKycComp from "@/app/refer/components/start-kyc";
import ReferCalculator from "@/app/refer/components/refer-calculator";
// import ReferDrawer from "@/app/refer/components/refer-drawer";
// import GoogleRecaptcha from "@/app/hooks/google-recaptcha";
import ICMWrapper from "@/app/components/icm-wrapper";
import ReferVoucher from "@/app/refer/components/refer-voucher";

/* const RECAPTCHA_CONFIG = {
    enabled: process.env.APP_RECAPTCHA_ENABLED === "true", // Control via env variable
    siteKey: process.env.APP_RECAPTCHA_KEY || "",
}; */

interface ReferProps {
    voucherAmt?: number;
    voucherText?: string;
    active?: string;
    setactive?: (value: string) => void; // Added setactive prop
    footerText?: string;
    title?: string;
    description?: string;
    isAuthenticated?: boolean;
    authLoading?: boolean;
    hideRewardsTab?: boolean;
    hideDashboardLink?: boolean;
    hideTransactionBenefit?: boolean;
}

const ReferAndEarnPrelogin: React.FC<ReferProps> = ({
    active,
    setactive,
    footerText,
    title,
    description,
    isAuthenticated,
    authLoading,
    voucherAmt,
    voucherText,
    // hideRewardsTab,
    // hideDashboardLink,
    hideTransactionBenefit,
}) => {
    const [amtValue, setAmtValue] = useState<number>(100000);
    const [noOfFriends, setNoOfFriends] = useState<number>(5);
    const [activeTab, setActiveTab] = useState<string>("refer");

    const [isKycDone/* , setisKycDone */] = useState<boolean>(false);

    const [loading/* , setLoading */] = useState<boolean>(true);
    // const pathname = usePathname();
    // const router = useRouter();

    const tabTitleData = {
        rewards: {
            title: isKycDone ? "You're ready to invest!" : "Complete your KYC!",
            description: `${isKycDone ? "Thank you for completing your KYC.<br/>" : ""}Buy Unlisted Shares and earn ₹200 cashback + 0.25% discount<br/> on 1st transaction`,
        },
        refer: {
            title: isKycDone ? "Referral Program" : "Refer & Earn up to ₹10,000",
            description: isKycDone
                ? "Introducing our exciting referral Program - your opportunity to earn rewards while sharing the love with friends and family!"
                : "The more successful referrals you make, the more rewards you can unlock.",
        },
    };

    const handleFriendsChange = (increment: boolean) => {
        setNoOfFriends((prev) => Math.max(0, prev + (increment ? 1 : -1)));
    };

    const calculateReturns = React.useCallback(() => {
        if (amtValue <= 0 || noOfFriends <= 0) {
            return 0;
        }

        const transactionBenefit = 0.01 * amtValue;
        const totalBenefitPerUser = transactionBenefit + AMZ_VOUCHER;

        return Math.min(totalBenefitPerUser, MAX_EARNING) * noOfFriends;
    }, [amtValue, noOfFriends]);

    const referTabContent = () => {
        if (authLoading || (isAuthenticated && loading)) {
            // Show nothing or a minimal full-loader here (if needed)
            return (
                <>
                    <ICMWrapper>
                        <div className="flex flex-col items-center justify-center gap-s14 py-s9 md:flex-row md:justify-between md:gap-s17 md:py-s17">
                            <ReferVoucher
                                isLoading={authLoading}
                                voucherAmt={voucherAmt}
                                voucherText={voucherText}
                                hideTransactionBenefit={hideTransactionBenefit}
                            />
                            <div className="flex flex-1 animate-pulse flex-col items-center justify-center rounded-3xl bg-white shadow-lg">
                                <div className="w-full border-b px-s13 py-s9 text-center text-lg font-semibold leading-[23px] text-neutral-900">
                                    <div className="mx-auto h-6 w-1/3 rounded bg-neutral-200" />
                                </div>
                                <div className="flex w-full flex-col flex-wrap sm:flex-row">
                                    <div className="flex flex-1 flex-col gap-s11 px-s13 py-s8 md:py-s14">
                                        <div className="flex flex-col items-center justify-center gap-s4">
                                            <div className="h-4 w-2/3 rounded bg-neutral-200" />
                                            <div className="flex items-center justify-center gap-s8">
                                                <div className="h-10 w-10 rounded-full bg-neutral-200" />
                                                <div className="h-8 w-12 rounded bg-neutral-200" />
                                                <div className="h-10 w-10 rounded-full bg-neutral-200" />
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center justify-center gap-s5">
                                            <div className="h-4 w-2/3 rounded bg-neutral-200" />
                                            <div className="h-8 w-24 rounded bg-neutral-200" />
                                            <div className="h-2 w-full rounded bg-neutral-200" />
                                        </div>
                                    </div>
                                    <div className="my-s8 flex flex-1 items-center justify-center sm:mr-s6">
                                        <div className="flex h-full min-w-[85%] max-w-[85%] items-center justify-center rounded-xl bg-neutral-50 py-s6 md:min-w-[90%] md:max-w-[90%] md:px-s13 md:py-s9">
                                            <div className="flex w-full flex-col items-center gap-s4 p-s9">
                                                <div className="h-4 w-1/3 rounded bg-neutral-200" />
                                                <div className="h-10 w-1/2 rounded bg-neutral-200" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ICMWrapper>
                    <div className="flex w-full flex-col items-center justify-center gap-s9 px-s9">
                        <div className="h-12 w-full rounded bg-neutral-200" />
                        <div className="h-4 w-2/3 rounded bg-neutral-200" />
                    </div>
                </>
            );
        }

        return (
            <ReferCalculator
                active={active}
                noOfFriends={noOfFriends}
                handleFriendsChange={handleFriendsChange}
                amtValue={amtValue}
                setAmtValue={setAmtValue}
                calculateReturns={calculateReturns}
                footerText={footerText}
                authLoading={false} // No longer loading
                voucherAmt={voucherAmt}
                voucherText={voucherText}
                hideTransactionBenefit={hideTransactionBenefit}
            />
        );
    };

    return (
        <div
            className={`py-s18 md:px-s9 md:pb-s20 bg-white`}
        >
            <Tabs
                defaultValue={"refer"}
                className="w-full md:mx-auto md:!w-[1152px]"
                onValueChange={(value) => {
                    if (setactive) {
                        setactive(value);
                    }
                    setActiveTab(value);
                }}
            >
                <>
                    {(active === "unlisted-shares" || activeTab === "refer") &&
                        (authLoading ? (
                            // Skeleton loader for header/title/description
                            <div className="mx-6 my-8 flex animate-pulse flex-col items-center justify-center gap-5 text-center md:mx-0 md:my-14 md:mb-0 md:mt-6">
                                <div className="mx-auto mb-3 h-12 w-2/3 max-w-[828px] rounded bg-neutral-200 md:h-16" />
                                <div className="mx-auto h-6 w-1/2 rounded bg-neutral-200 md:h-8" />
                            </div>
                        ) : active === "unlisted-shares" ? (
                            <div className="mx-s9 mb-0 mt-6 flex flex-col items-center justify-center text-center md:my-14">
                                <h2
                                    className="mx-auto mb-3 max-w-[828px] text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-neutral-900 md:mb-0 md:text-7xl md:leading-[67px] md:tracking-[-0.56px]"
                                    dangerouslySetInnerHTML={{ __html: title as string }}
                                />
                                <div
                                    className="mx-auto text-md leading-[25.6px] tracking-[-0.2px] text-neutral-500 md:max-w-[872px] md:text-xl md:leading-[32px]"
                                    dangerouslySetInnerHTML={{ __html: description as string }}
                                />
                            </div>
                        ) : activeTab === "refer" ? (
                            <div className="mx-6 my-8 flex flex-col items-center justify-center gap-3 text-center md:mx-0 md:my-14 md:mb-0 md:mt-6">
                                <div
                                    className="mx-auto mb-2 max-w-[828px] text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-neutral-900 md:mb-0 md:text-6xl md:leading-[67px] md:tracking-[-0.56px]"
                                    dangerouslySetInnerHTML={{
                                        __html: tabTitleData[activeTab as keyof typeof tabTitleData]
                                            .title,
                                    }}
                                />
                                <div
                                    className="mx-auto text-md leading-[25.6px] tracking-[-0.2px] text-neutral-500 md:max-w-[872px] md:text-xl md:leading-[32px]"
                                    dangerouslySetInnerHTML={{
                                        __html: tabTitleData[activeTab as keyof typeof tabTitleData]
                                            .description,
                                    }}
                                />
                            </div>
                        ) : null)}
                </>

                <TabsContent value="refer">{referTabContent()}</TabsContent>
            </Tabs>
        </div>
    );
};

export default ReferAndEarnPrelogin;
